module.exports = __webpack_public_path__ + "img/14.b84b5bae.jpg";